module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image-toggle-field"
  }, [_c('span', {
    staticClass: "glyphicon",
    class: _vm.glyphiconClass,
    on: {
      "click": function($event) {
        _vm.toggleValue()
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e6ea8814"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/elements/ImageToggle.vue
// module id = 1123
// module chunks = 0